import { gql } from "@apollo/client";

export const NOTIFICATIONS = gql`
  query Notifications(
    $where: NotificationWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
    $isNotIn: JSONObject
  ) {
    notifications(
      where: $where
      take: $take
      skip: $skip
      orderBy: $orderBy
      isNotIn: $isNotIn
    ) {
      data {
        id
        type
        importance
        title
        content
        meta
        createdDate
        isReadBy {
          id
        }
      }
      count
    }
  }
`;

export const UNREAD_NOTIFICATIONS_COUNT = gql`
  query UnreadNotificationsCount {
    unreadNotificationsCount
  }
`;

const notifications = { NOTIFICATIONS, UNREAD_NOTIFICATIONS_COUNT };

export default notifications;
